export const EXPENSE_TYPE_DOCUMENT_DROP_DOWN_ITEMS = []